import React from "react";
import ReactDOM from "react-dom/client";
import App from "./Components/App";
import { ScrollContextProvider } from "./Components/Context/ScrollContext";
import { ThemeContextProvider } from "./Components/Context/ThemeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ScrollContextProvider>
      <ThemeContextProvider>
        <App />
      </ThemeContextProvider>
    </ScrollContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
